import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { AircraftMakeModelEntity } from './aircraft-make-model.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum AircraftMakeModelActionTypes {
  LoadAircraftMakeModels = '[AircraftMakeModel] Load AircraftMakeModels',
  AddAircraftMakeModel = '[AircraftMakeModel] Add AircraftMakeModel',
  UpsertAircraftMakeModel = '[AircraftMakeModel] Upsert AircraftMakeModel',
  AddAircraftMakeModels = '[AircraftMakeModel] Add AircraftMakeModels',
  UpsertAircraftMakeModels = '[AircraftMakeModel] Upsert AircraftMakeModels',
  UpdateAircraftMakeModel = '[AircraftMakeModel] Update AircraftMakeModel',
  UpdateAircraftMakeModels = '[AircraftMakeModel] Update AircraftMakeModels',
  DeleteAircraftMakeModel = '[AircraftMakeModel] Delete AircraftMakeModel',
  DeleteAircraftMakeModels = '[AircraftMakeModel] Delete AircraftMakeModels',
  ClearAircraftMakeModels = '[AircraftMakeModel] Clear AircraftMakeModels',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadAircraftMakeModels implements Action {
  public readonly type = AircraftMakeModelActionTypes.LoadAircraftMakeModels;

  constructor(public payload: { aircraftMakeModels: AircraftMakeModelEntity[] }) {}
}

export class AddAircraftMakeModel implements Action {
  public readonly type = AircraftMakeModelActionTypes.AddAircraftMakeModel;

  constructor(public payload: { aircraftMakeModel: AircraftMakeModelEntity }) {}
}

export class UpsertAircraftMakeModel implements Action {
  public readonly type = AircraftMakeModelActionTypes.UpsertAircraftMakeModel;

  constructor(public payload: { aircraftMakeModel: AircraftMakeModelEntity }) {}
}

export class AddAircraftMakeModels implements Action {
  public readonly type = AircraftMakeModelActionTypes.AddAircraftMakeModels;

  constructor(public payload: { aircraftMakeModels: AircraftMakeModelEntity[] }) {}
}

export class UpsertAircraftMakeModels implements Action {
  public readonly type = AircraftMakeModelActionTypes.UpsertAircraftMakeModels;

  constructor(public payload: { aircraftMakeModels: AircraftMakeModelEntity[] }) {}
}

export class UpdateAircraftMakeModel implements Action {
  public readonly type = AircraftMakeModelActionTypes.UpdateAircraftMakeModel;

  constructor(public payload: { aircraftMakeModel: Update<AircraftMakeModelEntity> }) {}
}

export class UpdateAircraftMakeModels implements Action {
  public readonly type = AircraftMakeModelActionTypes.UpdateAircraftMakeModels;

  constructor(public payload: { aircraftMakeModels: Update<AircraftMakeModelEntity>[] }) {}
}

export class DeleteAircraftMakeModel implements Action {
  public readonly type = AircraftMakeModelActionTypes.DeleteAircraftMakeModel;

  constructor(public payload: { id: string }) {}
}

export class DeleteAircraftMakeModels implements Action {
  public readonly type = AircraftMakeModelActionTypes.DeleteAircraftMakeModels;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearAircraftMakeModels implements Action {
  public readonly type = AircraftMakeModelActionTypes.ClearAircraftMakeModels;
}

export type AircraftMakeModelActions =
  | LoadAircraftMakeModels
  | AddAircraftMakeModel
  | UpsertAircraftMakeModel
  | AddAircraftMakeModels
  | UpsertAircraftMakeModels
  | UpdateAircraftMakeModel
  | UpdateAircraftMakeModels
  | DeleteAircraftMakeModel
  | DeleteAircraftMakeModels
  | ClearAircraftMakeModels;
